<app-global-upload></app-global-upload>

<!-- vertical-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'vertical'">
  <vertical-layout></vertical-layout>
</ng-container>
<!-- / vertical-layout -->

<!-- horizontal-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'horizontal'">
  <horizontal-layout></horizontal-layout>
</ng-container>
<!-- / horizontal-layout -->

<!-- home-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'home-layout'">
  <home-layout></home-layout>
</ng-container>
<!-- / home-layout -->

<!-- Edge panel: accesos rápidos desde el borde izquierdo. Va acá y no dentro
     de un layout porque los tres (vertical, horizontal y home) lo usan. -->
<app-edge-panel [hideOnFullscreen]="true"></app-edge-panel>

<!-- Bryant: burbuja + panel acoplado. Vive fuera de los layouts para no
     remontarse en cada navegación y así conservar la conversación abierta. -->
<app-chat-dock></app-chat-dock>

<!-- theme customizer -->
<core-sidebar
  name="themeCustomizer"
  class="customizer d-none d-md-block"
  [invisibleOverlay]="true"
  *ngIf="coreConfig.layout.customizer"
>
  <a
    class="customizer-toggle d-flex align-items-center justify-content-center"
    (click)="toggleSidebar('themeCustomizer')"
  >
    <span [data-feather]="'settings'" [class]="'spinner'"></span>
  </a>
  <core-theme-customizer></core-theme-customizer>
</core-sidebar>
<!-- / theme customizer -->
